import { TypeGuardError } from 'src/core/utils/switchGuard';

import { type ApiBudgetDimension } from '../models/budgetTree';
import { type Dimension } from '../models/dimension';

export const convertDimensionFromApi = (
  apiDimension: ApiBudgetDimension,
): Dimension => {
  switch (apiDimension) {
    case 'costCenter':
    case 'expenseCategory':
    case 'supplier':
      return { type: apiDimension };
    default: {
      // const customFieldPrefix = 'customField_';
      // if (apiDimension.startsWith(customFieldPrefix)) {
      //   const customFieldId = apiDimension.replace(customFieldPrefix, '');
      //   return { type: 'customField', customFieldId };
      // }
      throw new Error(`Unknown dimension type: ${apiDimension}`);
    }
  }
};

export const convertDimensionToApi = (
  dimension: Dimension,
): ApiBudgetDimension => {
  switch (dimension.type) {
    case 'costCenter':
    case 'expenseCategory':
    case 'supplier':
      return dimension.type;
    // case 'customField':
    //   return `customField_${dimension.customFieldId}`;
    default:
      throw new TypeGuardError(dimension.type, 'Unknown dimension type');
  }
};
